import './DataRoom.scss';
import { DataRoomFundSelector } from './DataRoomFundSelector';
import { dataRoomApi} from 'api/dataRoomApi';
import classNames from 'classnames';
import { Button } from 'components/InteractiveUIControls/Button/Button';
import { BASE_FMS_URL } from 'components/ReportsModule/ReportSelectors';
import { Svgicon } from 'components/Svgicon/Svgicon';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { isMobile, isTablet } from 'services/mobile';
import { type DocumentsStoreState,
  type Filters,
  type FilterStoreState } from 'store/slices';
import { COLORS } from 'types/Colors';

type DataRoomBannerProps = {
  folderNames: string[],
  isTheOnlyOneBanner: boolean,
};

export const DataRoom = ({folderNames, isTheOnlyOneBanner}: DataRoomBannerProps) => {
  const activeFilters = useSelector<{
    filters: FilterStoreState,
  }>((state) => state.filters.activeFilters) as Filters | null;
  const firmId = activeFilters?.organizationId || '';
  const {
    otherCategories,
  } = useSelector<{ documents: DocumentsStoreState, }>(
    (state) => state.documents,
  ) as DocumentsStoreState;
  const [
    showModal,
    setShowModal,
  ] = useState(false);

  const onFolderSelected = async (folderName: string) => {
    const token = await dataRoomApi.getDataRoomToken({firmId,
      folderName});

    if (token) {
      const newWindow = window.open('', '_blank');
      const fmsUrl = `${BASE_FMS_URL}/documents/data-room/external?token=${token}`;
      if (newWindow) {
        newWindow.location.href = fmsUrl;
      }
    }
  };

  const handleButtonClick = () => {
    if (folderNames.length === 1) {
      onFolderSelected(folderNames[0]);
    } else {
      setShowModal(true);
    }
  };

  if (!otherCategories?.length && !folderNames.length) {
    return <>{isTablet() ? null
      : <div className='flex max-h-full w-full flex-col justify-between gap-[0.5rem] rounded-full bg-black-200 p-[1rem] ms:min-h-[9.4375rem] ms:gap-0.75 ms:rounded-medium ms:p-0.875' data-test='empty-card-data-room' />}</>;
  }

  return (
    <>
      <div
        className={classNames('data-room-card flex max-h-[7rem] w-full justify-between overflow-hidden rounded-medium bg-main-600 p-[1rem] hover:cursor-pointer ms:max-h-[9.4375rem] ms:gap-0.75 ms:p-0.875', {'ms:!max-h-full ms:!h-full': isTheOnlyOneBanner})}
        data-test='data-room-modal-open'
        onClick={handleButtonClick}
      >
        <div className='flex size-full flex-col justify-between gap-[0.5rem] ms:w-auto ms:gap-[1.9375rem]'>
          <div>
            <h3 className='m-0 truncate text-title-4 font-semibold text-white-999'>
              Data {!isMobile() && <br />}
              room
            </h3>
          </div>
          <div className='flex size-full justify-between'>
            <Button
              className='self-center overflow-hidden ms:!size-9 ms:self-end'
              data-test='data-room-modal-open'
              icon='only'
              iconClassName='icon-container size-[1.25rem]'
              iconColor={COLORS['$main-600']}
              iconid='arrow-right-2f'
              size='medium'
              squared
              tooltipWrapperClass='!justify-start'
              type='white'
            />
            {isTablet() ? <div> <Svgicon className='size-[12.5rem]' id='data-room-banner' /></div> : null}
          </div>
        </div>
        {isTablet() ? null : <Svgicon className='size-[12.5rem]' id='data-room-banner' />}
      </div>
      {showModal && <DataRoomFundSelector
        folderNames={folderNames}
        onClose={() => setShowModal(false)}
        onFolderSelected={onFolderSelected}
      />}
    </>
  );
};
